// extracted by mini-css-extract-plugin
export var colorSquare = "_tf-0";
export var danger = "_tf-5";
export var lightPink = "_tf-8";
export var neutralBlue = "_tf-7";
export var neutralYellow = "_tf-6";
export var normal = "_tf-1";
export var primary = "_tf-2";
export var primaryLight = "_tf-3";
export var solidBlack = "_tf-g";
export var solidGreen = "_tf-b";
export var solidLightBlue = "_tf-d";
export var solidNavy = "_tf-c";
export var solidOrange = "_tf-f";
export var solidPink = "_tf-e";
export var solidRed = "_tf-9";
export var solidYellow = "_tf-a";
export var success = "_tf-4";